import AnimationClip from '../AnimationClip';
import { Easing } from '@tweenjs/tween.js';
import GameObject from '../../../GameObject/GameObject';
import { delay } from '../../../Utility/Task/TaskQueue';
import { AwaitIterators, StartAnimation } from '../AnimationHelper';
import ElementComponent from '../../../Component/UI/Element';
import Renderable from '../../../Component/Renderable';

export class ThreeStarRewardTextPopIn extends AnimationClip {
    protected height: number = 180;
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        const element = gameObject.getComponent(ElementComponent);
        const renderable = gameObject.getComponent(Renderable);
        //const textComponent = gameObject.getComponent(TextComponent);
        const offset: number = meta && meta.offset ? meta.offset : this.height;

        element.layout.scale = [0.1, 0.1];

        yield* delay(500);

        //textComponent.visible = true;

        const tweenPosition = this.getTween(element.layout.offsets);
        const tweenScale = this.getTween(element.layout.scale);
        const tweenScaleBack = this.getTween(element.layout.scale);
        const tweenAlpha = this.getTween(renderable);

        tweenPosition.to(
            {
                1: element.layout.offsets[1] + offset,
                3: element.layout.offsets[3] + offset,
            },
            300
        );

        tweenScale.to({ 0: 1.5, 1: 1.5 }, 300).easing(Easing.Back.Out);

        tweenScaleBack.to({ 0: 1, 1: 1 }, 300).easing(Easing.Back.Out);

        tweenAlpha.to({ alpha: 1 }, 300).easing(Easing.Back.Out);

        yield* AwaitIterators([
            this.startTween(tweenAlpha),
            this.startTween(tweenPosition),
            this.startTween(tweenScale),
        ]);
        yield* this.startTween(tweenScaleBack);
        /*
        yield* delay(15000);
        StartAnimation(gameObject, 'Alpha', {
            startAlpha: 1,
            endAlpha: 0,
            duration: 500,
        })
        */
    }
}
